Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp;
  var counter = {
    flexShrink: 0,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    counter.flexDirection = 'column';
  }
  var number = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.l,
    lineHeight: _styles.STYLES.lineHeight.l,
    color: colors.brand,
    marginHorizontal: spacing.xs
  });
  var haveDoneText = Object.assign({}, fontRegular, {
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.l,
    flexWrap: 'wrap'
  });
  var tick = {
    width: (0, _styles.getREM)(2),
    height: (0, _styles.getREM)(2),
    flexShrink: 0
  };
  var text = {
    flexDirection: 'row',
    alignItems: 'center'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    text.flexDirection = 'column';
  }
  var styles = _reactNative.StyleSheet.create({
    counter: counter,
    number: number,
    haveDoneText: haveDoneText,
    tick: tick,
    text: text
  });
  return {
    styles: styles
  };
};